import * as yup from "yup";

import { checkSINValidity } from "../../../components/T4Slip/T4SlipSetup/validator";

// export const T3SlipSetupValidationSchema = yup.object({
//   recipientType: yup.number().nullable().required("Recipient Type is required"),
//   initials: yup.string().nullable()
//     .when('recipientType', {
//       is: (value:number) => value === 10 || value === 20,
//       then: yup.string().max(1, "maximum one character"),
//       otherwise: yup.string().nullable()
//     }),
//   name1: yup.string().nullable()
//     .when('recipientType', {
//       is: (value:number) => value === 10 || value === 20,
//       then: yup.string().required('First Name is required').max(12, "First Name has at most 12 characters"),
//       otherwise: yup.string().nullable()
//     }),
//   // name1: yup.string().nullable()
//   //   .when('recipientType', (recipientType, schema) => {
//   //     if (recipientType === 10 || recipientType === 20) {
//   //       return schema.required('First Name is required').max(12, "First Name has at most 12 characters");
//   //     }
//   //     return schema;
//   //   }),
//   name2: yup.string().nullable()
//     .when('recipientType', {
//       is: (value:number) => value === 10 || value === 20,
//       then: yup.string().nullable().required('Last Name is required').max(20, "Last Name has at most 20 characters"),
//       otherwise: yup.string().nullable()
//     }),
//   secondRecipientName: yup.string().nullable()
//     .when('recipientType', {
//       is: 20,
//       then: yup.string().nullable().required('Second Recipient Name is required'),
//       otherwise: yup.string().nullable()
//     }),
//   firstLineOfRecipientName: yup.string().nullable()
//     .when('recipientType', {
//       is: (value:number) => value === 30 || value === 40 || value === 50,
//       then: yup.string().nullable().required('First Line Of Recipient Name is required').max(12, "First Line Of Recipient Name has at most 12 characters"),
//       otherwise: yup.string().nullable()
//     }),
//     secondLineOfRecipientName: yup.string().nullable()
//     .when('recipientType', {
//       is: (value:number) => value === 30 || value === 40 || value === 50,
//       then: yup.string().nullable().required('Second Line Of Recipient Name is required'),
//       otherwise: yup.string().nullable()
//     }),

//     addressLine1: yup
//     .string()
//     .required("Address is required")
//     .max(50, "Address has at most 50 characters"),

//   city: yup
//     .string()
//     .required("City is required")
//     .max(28, "City has at most 28 characters"),

//   province: yup.string().nullable().required("Province is required"),
//   // provinceOfEmployment: yup.string().nullable().required("Province of employment is required"),

//   postalCode: yup
//     .string()
//     .required("PostCode is required"),

//   country: yup.mixed().test(
//     'is-string-or-object',
//     'Input must be a string or an object.',
//     (value) => typeof value === 'string' || typeof value === 'object'
//   ).required("Country is required"),

//   slipType: yup.number().required("slipType is required"),

//   slipStatus: yup.number().required("slip Status is required"),

//   transit: yup
//   .string().nullable()
//   .max(8, "Transit has at most 8 characters"),
//   optionalTextToPrintOnTheSlip: yup
//   .string().nullable()
//   .max(11, "Optional Text has at most 11 characters"),
// recipientAccount: yup
//   .string().nullable()
//   .max(12, "Recipient Account has at most 12 characters"),

//   uniqueIdentifier: yup.string().nullable()
//     .when('recipientType', {
//       is: (value:number) => value === 10 || value === 20,
//       then:yup.string().nullable().test(
//       'is-masked-or-not',
//       'Invalid value',
//       function (value:any) {
//         let sin = value && value.replace(/-/g, '')
//         const output = checkSINValidity(sin);

//         let maxLength = 11;

//         if (value && value.charAt(2) === '*') {
//           maxLength = 7;
//           if (value && value.length == maxLength) {
//             return true;
//           } else {
//             return this.createError({
//               message: 'Invalid Social Insuarance Number',
//               path: this.path,
//             });
//           }
//         } else {
//           if (value && value.length == maxLength && output % 10 === 0) {
//             return true;
//           } else {
//             return this.createError({
//               message: 'Invalid Social Insuarance Number',
//               // message: 'Social Insuarance Number has at least 9 characters',
//               path: this.path,
//             });
//           }
//         }
//       }
//     ).required('Social Insuarance is required'),
//     otherwise: yup.string().nullable()
//     }),

//   businessNumber: yup.string().nullable()
//     .when('recipientType', {
//       is: (value:number) => value === 30 || value === 50,
//       then:yup.string().test(
//           'is-valid-or-not',
//           'Invalid value',
//           function (value:any) {
//             let maxLength = 15;

//             const firstNineDigits: string = value && value.substring(0, 9);

//             const output = checkSINValidity(firstNineDigits);

//               if (value && value.length == maxLength && output % 10 === 0) {
//                 return true;
//               } else {
//                 return this.createError({
//                   message: 'Invalid Business Number',
//                   path: this.path,
//                 });
//               }
//           }
//         ).nullable().required('business Number is required'),
//     otherwise: yup.string().nullable()
//     }),

//   trustAccountNumber: yup.string().nullable()
//     .when('recipientType', {
//       is: 40,
//       then:yup.string().required('Trust Account Number is required'),
//     otherwise: yup.string().nullable()
//     }),

//     email: yup
//     .string().nullable()
//     .email("Please enter valid Email"),
// });

// with v20.12.21

export const T3SlipSetupValidationSchema = yup.object({
  // recipientType: yup.number().nullable().required("Recipient Type is required"),

  // initials: yup
  //   .string()
  //   .nullable()
  //   .when("recipientType", {
  //     is: (value: number) => value === 10 || value === 20,
  //     then: (schema) => schema.max(1, "Maximum one character"),
  //     otherwise: (schema) => schema.nullable(),
  //   }),

  // name1: yup
  //   .string()
  //   .nullable()
  //   .when("recipientType", {
  //     is: (value: number) => value === 10 || value === 20,
  //     then: (schema) =>
  //       schema
  //         .required("First Name is required")
  //         .max(12, "First Name has at most 12 characters"),
  //     otherwise: (schema) => schema.nullable(),
  //   }),

  // name2: yup
  //   .string()
  //   .nullable()
  //   .when("recipientType", {
  //     is: (value: number) => value === 10 || value === 20,
  //     then: (schema) =>
  //       schema
  //         .required("Last Name is required")
  //         .max(20, "Last Name has at most 20 characters"),
  //     otherwise: (schema) => schema.nullable(),
  //   }),

  // secondRecipientName: yup
  //   .string()
  //   .nullable()
  //   .when("recipientType", {
  //     is: 20,
  //     then: (schema) => schema.required("Second Recipient Name is required"),
  //     otherwise: (schema) => schema.nullable(),
  //   }),

  // firstLineOfRecipientName: yup
  //   .string()
  //   .nullable()
  //   .when("recipientType", {
  //     is: (value: number) => [30, 40, 50].includes(value),
  //     then: (schema) =>
  //       schema
  //         .required("First Line Of Recipient Name is required")
  //         .max(12, "First Line Of Recipient Name has at most 12 characters"),
  //     otherwise: (schema) => schema.nullable(),
  //   }),

  // secondLineOfRecipientName: yup
  //   .string()
  //   .nullable()
  //   .when("recipientType", {
  //     is: (value: number) => [30, 40, 50].includes(value),
  //     then: (schema) =>
  //       schema.required("Second Line Of Recipient Name is required"),
  //     otherwise: (schema) => schema.nullable(),
  //   }),

  // addressLine1: yup
  //   .string()
  //   .required("Address is required")
  //   .max(50, "Address has at most 50 characters"),

  // city: yup
  //   .string()
  //   .required("City is required")
  //   .max(28, "City has at most 28 characters"),

  // province: yup.string().nullable().required("Province is required"),

  // postalCode: yup.string().required("PostCode is required"),

  // country: yup
  //   .mixed()
  //   .test(
  //     "is-string-or-object",
  //     "Input must be a string or an object.",
  //     (value) => typeof value === "string" || typeof value === "object"
  //   )
  //   .required("Country is required"),

  // slipType: yup.number().required("Slip Type is required"),

  // slipStatus: yup.number().required("Slip Status is required"),

  // transit: yup.string().nullable().max(8, "Transit has at most 8 characters"),

  // optionalTextToPrintOnTheSlip: yup
  //   .string()
  //   .nullable()
  //   .max(11, "Optional Text has at most 11 characters"),

  // recipientAccount: yup
  //   .string()
  //   .nullable()
  //   .max(12, "Recipient Account has at most 12 characters"),

  // uniqueIdentifier: yup
  //   .string()
  //   .nullable()
  //   .when("recipientType", {
  //     is: (value: number) => value === 10 || value === 20,
  //     then: (schema) =>
  //       schema
  //         .test("is-masked-or-not", "Invalid value", function (value: any) {
  //           if (!value) {
  //             return this.createError({
  //               message: "Social Insurance Number is required",
  //               path: this.path,
  //             });
  //           }

  //           let sin = value.replace(/-/g, "");
  //           const output = checkSINValidity(sin);
  //           let maxLength = 11;

  //           if (value.charAt(2) === "*") {
  //             maxLength = 7;
  //             if (value.length === maxLength) return true;
  //           } else if (value.length === maxLength && output % 10 === 0) {
  //             return true;
  //           }

  //           return this.createError({
  //             message: "Invalid Social Insurance Number",
  //             path: this.path,
  //           });
  //         })
  //         .required("Social Insurance Number is required"),
  //     otherwise: (schema) => schema.nullable(),
  //   }),

  // businessNumber: yup
  //   .string()
  //   .nullable()
  //   .when("recipientType", {
  //     is: (value: number) => value === 30 || value === 50,
  //     then: (schema) =>
  //       schema
  //         .test("is-valid-or-not", "Invalid value", function (value: any) {
  //           if (!value) {
  //             return this.createError({
  //               message: "Business Number is required",
  //               path: this.path,
  //             });
  //           }

  //           let maxLength = 15;
  //           const firstNineDigits = value.substring(0, 9);
  //           const output = checkSINValidity(firstNineDigits);

  //           if (value.length === maxLength && output % 10 === 0) return true;

  //           return this.createError({
  //             message: "Invalid Business Number",
  //             path: this.path,
  //           });
  //         })
  //         .required("Business Number is required"),
  //     otherwise: (schema) => schema.nullable(),
  //   }),

  // trustAccountNumber: yup
  //   .string()
  //   .nullable()
  //   .when("recipientType", {
  //     is: 40,
  //     then: (schema) => schema.required("Trust Account Number is required"),
  //     otherwise: (schema) => schema.nullable(),
  //   }),

  // email: yup.string().nullable().email("Please enter a valid Email"),


  recipientType: yup.number().nullable().required("Recipient Type is required"),

  initials: yup
    .string()
    .nullable()
    .test("validate-initials", "Maximum one character", function (value) {
      const recipientType = this.parent.recipientType;
      if (recipientType === 10 || recipientType === 20) {
        if (value && value.length > 1) {
          return this.createError({
            message: "Maximum one character",
            path: this.path,
          });
        }
      }
      return true;
    }),

  name1: yup
    .string()
    .nullable()
    .test("validate-name1", "Invalid First Name", function (value) {
      const recipientType = this.parent.recipientType;
      if (recipientType === 10 || recipientType === 20) {
        if (!value)
          return this.createError({
            message: "First Name is required",
            path: this.path,
          });
        if (value.length > 12)
          return this.createError({
            message: "First Name has at most 12 characters",
            path: this.path,
          });
      }
      return true;
    }),

  name2: yup
    .string()
    .nullable()
    .test("validate-name2", "Invalid Last Name", function (value) {
      const recipientType = this.parent.recipientType;
      if (recipientType === 10 || recipientType === 20) {
        if (!value)
          return this.createError({
            message: "Last Name is required",
            path: this.path,
          });
        if (value.length > 20)
          return this.createError({
            message: "Last Name has at most 20 characters",
            path: this.path,
          });
      }
      return true;
    }),

  secondRecipientName: yup
    .string()
    .nullable()
    .test("validate-second-recipient-name", "Second Recipient Name is required", function (value) {
      const recipientType = this.parent.recipientType;
      if (recipientType === 20 && !value) {
        return this.createError({
          message: "Second Recipient Name is required",
          path: this.path,
        });
      }
      return true;
    }),

  firstLineOfRecipientName: yup
    .string()
    .nullable()
    .test("validate-first-line", "Invalid First Line", function (value) {
      const recipientType = this.parent.recipientType;
      if ([30, 40, 50].includes(recipientType)) {
        if (!value)
          return this.createError({
            message: "First Line Of Recipient Name is required",
            path: this.path,
          });
        if (value.length > 12)
          return this.createError({
            message: "First Line Of Recipient Name has at most 12 characters",
            path: this.path,
          });
      }
      return true;
    }),

  secondLineOfRecipientName: yup
    .string()
    .nullable()
    .test("validate-second-line", "Invalid Second Line", function (value) {
      const recipientType = this.parent.recipientType;
      if ([30, 40, 50].includes(recipientType) && !value) {
        return this.createError({
          message: "Second Line Of Recipient Name is required",
          path: this.path,
        });
      }
      return true;
    }),

  addressLine1: yup
    .string()
    .required("Address is required")
    .max(50, "Address has at most 50 characters"),

  city: yup.string().required("City is required").max(28, "City has at most 28 characters"),

  province: yup.string().nullable().required("Province is required"),

  postalCode: yup.string().required("PostCode is required"),

  country: yup
    .mixed()
    .test(
      "is-string-or-object",
      "Input must be a string or an object.",
      (value) => typeof value === "string" || typeof value === "object"
    )
    .required("Country is required"),

  slipType: yup.number().required("Slip Type is required"),

  slipStatus: yup.number().required("Slip Status is required"),

  transit: yup.string().nullable().max(8, "Transit has at most 8 characters"),

  optionalTextToPrintOnTheSlip: yup
    .string()
    .nullable()
    .max(11, "Optional Text has at most 11 characters"),

  recipientAccount: yup
    .string()
    .nullable()
    .max(12, "Recipient Account has at most 12 characters"),

  uniqueIdentifier: yup
    .string()
    .nullable()
    .test("validate-sin", "Invalid SIN", function (value) {
      const recipientType = this.parent.recipientType;
      if (recipientType === 10 || recipientType === 20) {
        if (!value) {
          return this.createError({
            message: "Social Insurance Number is required",
            path: this.path,
          });
        }

        const sin = value.replace(/-/g, "");
        const output = checkSINValidity(sin);
        let maxLength = 11;

        if (value.charAt(2) === "*") {
          maxLength = 7;
          if (value.length === maxLength) return true;
          return this.createError({
            message: "Invalid Social Insurance Number",
            path: this.path,
          });
        }

        if (value.length === maxLength && output % 10 === 0) return true;

        return this.createError({
          message: "Invalid Social Insurance Number",
          path: this.path,
        });
      }
      return true;
    }),

  businessNumber: yup
    .string()
    .nullable()
    .test("validate-bn", "Invalid Business Number", function (value) {
      const recipientType = this.parent.recipientType;
      if (recipientType === 30 || recipientType === 50) {
        if (!value) {
          return this.createError({
            message: "Business Number is required",
            path: this.path,
          });
        }

        const maxLength = 15;
        const firstNineDigits = value.substring(0, 9);
        const output = checkSINValidity(firstNineDigits);

        if (value.length === maxLength && output % 10 === 0) return true;

        return this.createError({
          message: "Invalid Business Number",
          path: this.path,
        });
      }
      return true;
    }),

  trustAccountNumber: yup
    .string()
    .nullable()
    .test("validate-trust", "Trust Account Number is required", function (value) {
      const recipientType = this.parent.recipientType;
      if (recipientType === 40 && !value) {
        return this.createError({
          message: "Trust Account Number is required",
          path: this.path,
        });
      }
      return true;
    }),

  email: yup.string().nullable().email("Please enter a valid Email"),
});
